import script from "./USDTpayment.vue?vue&type=script&setup=true&lang=js"
export * from "./USDTpayment.vue?vue&type=script&setup=true&lang=js"

import "./USDTpayment.vue?vue&type=style&index=0&id=2b83e339&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b83e339"]])

export default __exports__